export default function VerifyDemandDraft() {
    return (
        <div>
            <h1>Verify Demand Draft</h1>
        </div>
    );
}